module.exports = __webpack_public_path__ + "img/forward-square.47aaf0a5.svg";